import styled from 'styled-components'

export const Sidebar = styled.div`
    min-width: 20%;
    padding: 20px;
    background: white;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
`